import DocumentApi from "../../../service/DocumentService";

export default {
  name: "MeetingPdfViewer",
  data() {
    return {
      content: undefined,
      loading: false
    };
  },
  beforeMount: function() {
    this.documentId =  this.$route.query.documentId;
  },
  mounted() {
      this.loading = true;
      this.retrieveMeetingPDF(this.documentId)
      .then((document) => {
        if (document) {
          debugger;
          const blob = this.b64toBlob(document);
          this.content = URL.createObjectURL(blob);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    async retrieveMeetingPDF(documentId) {
      return new Promise((resolve) => {
        DocumentApi.getDocumentById(
          this,
          documentId,
          (response) => {
            if (
              response &&
              response.documentDTO &&
              response.documentDTO.result &&
              response.documentDTO.result.documentFile &&
              response.documentDTO.result.documentFile.base64Bytes
            ) {
              resolve(
                response.documentDTO.result.documentFile.base64Bytes
              );
            }
            resolve();
          },
          (error) => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    b64toBlob(b64Data) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      const sliceSize = 512;

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });
      debugger;
      return blob;
    },

   
  }
};



// WEBPACK FOOTER //
// ./src/pages/meetingpdfviewer/mixin/MeetingPdfViewer.js